import Backbone from "backbone";
import FlashSales from "../models/FlashSales";
import $ from "jquery";

export default Backbone.View.extend({
    /**
      * @class FlashSalesView
      *
      * @augments Backbone.View
      * @constructs
      *
      * Handle flash sales
    */
    initialize: function () {
      this.nodeID = this.$el.attr("data-id")
      this.model = new FlashSales({ nodeID: this.nodeID })
      this.page = 1
      this.html = null

      this.listenTo(this.model, "change", this.checkHtml);
    },

    events: {
      "click .js-FlashSales-more": "loadMore"
    },


    loadMore: function () {
      this.page += 1;
      this.render();
    },

    checkHtml: function () {
      if (this.model.get("html")) {
        this.render();
      }
    },

    /**
     * propagates the current state to the DOM
     */
    render: function () {
      if (this.model.get("html")) {
        this.$(".js-FlashSales-content").append(this.model.get("html"));
        this.model.clear().set(this.model.defaults);
      } else if (this.model.get("html") === "") {
        this.$(".js-FlashSales-more").addClass("flashSales-more--disabled");
      } else {
        this.model.fetch({ nodeID: this.nodeID, page: this.page });
      }
    }
  });
